import React from 'react';

import { Center, Box } from '@tapresearch/ui/components';

export const QuestionNumber = ({ num, boxStyles = {}, textStyles = {} }) => {
  return (
    <Center {...QuestionNumStyles} {...boxStyles}>
      <Box
        as="span"
        {...{
          fontSize: 'md',
          fontWeight: 'bold',
          color: 'gray.800',
        }}
        {...textStyles}
      >
        {num}
      </Box>
    </Center>
  );
};

const QuestionNumStyles = {
  variant: 'square',
  rounded: 'md',
  mr: 4,
  w: '28px',
  h: '28px',
  bg: 'blue.100',
};
